import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './Button';
export const ClosingSection = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 px-4 md:px-8 bg-brand-charcoal text-white" data-id="element-53">
      <div className="max-w-4xl mx-auto text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-cream" data-id="element-56">
            Tienes dos caminos hoy.
          </h2>

          <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-57">
            <div className="bg-white/5 p-8 rounded-2xl border border-white/10" data-id="element-58">
              <h3 className="text-xl font-bold text-brand-crimson mb-4 flex items-center gap-2" data-id="element-59">
                <span className="w-8 h-8 rounded-full bg-brand-crimson/20 flex items-center justify-center text-sm" data-id="element-60">
                  A
                </span>
                El Camino A
              </h3>
              <p className="text-white/80 leading-relaxed" data-id="element-61">
                Seguir intentando las mismas dietas que te agotan y te inflaman,
                aceptando el cansancio como "parte de la edad".
              </p>
            </div>

            <div className="bg-brand-green/20 p-8 rounded-2xl border border-brand-green/50 relative overflow-hidden" data-id="element-62">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/30 rounded-bl-full -z-10 blur-xl" data-id="element-63"></div>
              <h3 className="text-xl font-bold text-brand-gold mb-4 flex items-center gap-2" data-id="element-64">
                <span className="w-8 h-8 rounded-full bg-brand-gold/20 flex items-center justify-center text-sm" data-id="element-65">
                  B
                </span>
                El Camino B
              </h3>
              <p className="text-white/90 leading-relaxed font-medium" data-id="element-66">
                Unirte a miles de mujeres que han recuperado su vitalidad
                hackeando su biología.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};